var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCopy(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 31,
    height: 31,
    rx: 5.5,
    fill: "#BAE2FF",
    stroke: "#0079FF"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14 20C13.6333 20 13.3194 19.8695 13.0583 19.6083C12.7972 19.3472 12.6667 19.0333 12.6667 18.6667V10.6667C12.6667 10.3 12.7972 9.98612 13.0583 9.72501C13.3194 9.4639 13.6333 9.33334 14 9.33334H20C20.3667 9.33334 20.6806 9.4639 20.9417 9.72501C21.2028 9.98612 21.3333 10.3 21.3333 10.6667V18.6667C21.3333 19.0333 21.2028 19.3472 20.9417 19.6083C20.6806 19.8695 20.3667 20 20 20H14ZM11.3333 22.6667C10.9667 22.6667 10.6528 22.5361 10.3917 22.275C10.1306 22.0139 10 21.7 10 21.3333V12H11.3333V21.3333H18.6667V22.6667H11.3333Z",
    fill: "#0066FF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCopy);
export default __webpack_public_path__ + "static/media/copy.56c8a1e16164c5dd850f105bb35e6406.svg";
export { ForwardRef as ReactComponent };